import { Context, Effect, Layer } from 'effect';
import api from './api.js';

// This wraps existing Api object with Effect Service to inject to other Services as dependency
export interface ApiService {
  readonly getDevices: typeof api.getDevices;
  readonly getHashDevices: typeof api.getHashDevices;
  readonly connectHashDevice: typeof api.connectHashDevice;
  readonly saveHashCompanyId: typeof api.saveHashCompanyId;
  readonly signIn: typeof api.signIn;
  readonly checkTwoFACode: typeof api.checkTwoFACode;
  readonly resendTwoFACode: typeof api.resendTwoFACode;
  readonly signInSage: typeof api.signInSage;
  readonly companyLogin: typeof api.companyLogin;
  readonly saveSageCompany: typeof api.saveSageCompany;
  readonly signInPriority: typeof api.signInPriority;
  readonly signInSAP: typeof api.signInSAP;
  readonly signInNetSuite: typeof api.signInNetSuite;
  readonly signInMDNavision: typeof api.signInMDNavision;
  readonly saveMDNavisionCompany: typeof api.saveMDNavisionCompany;
  readonly signInMDBC: typeof api.signInMDBC;
  readonly saveMDBCCompany: typeof api.saveMDBCCompany;
  readonly signInAcumatica: typeof api.signInAcumatica;
  readonly signInAcumaticaAdvanced: typeof api.signInAcumaticaAdvanced;
  readonly signInHashWeb: typeof api.signInHashWeb;
  readonly savePriorityCompany: typeof api.savePriorityCompany;
  readonly signInSAP4Hana: typeof api.signInSAP4Hana;
  readonly saveSAP4Hana: typeof api.saveSAP4Hana;
  readonly getZohoCompanyList: typeof api.getZohoCompanyList;
  readonly setZohoCompany: typeof api.setZohoCompany;
  readonly getCompanies: typeof api.getCompanies;
  readonly markCompanyPinned: typeof api.markCompanyPinned;
  readonly getListRecent: typeof api.getListRecent;
  readonly getDocumentsExportFormats: typeof api.getDocumentsExportFormats;
  readonly documentSearch: typeof api.documentSearch;
  readonly documentSearchByCategory: typeof api.documentSearchByCategory;
  readonly documentSearchBySupplier: typeof api.documentSearchBySupplier;
  readonly searchInCompanies: typeof api.searchInCompanies;
  readonly getDocument: typeof api.getDocument;
  readonly getOptionsList: typeof api.getOptionsList;
  readonly removeDocument: typeof api.removeDocument;
  readonly updateDocumentTags: typeof api.updateDocumentTags;
  readonly updateMultipleDocumentsTags: typeof api.updateMultipleDocumentsTags;
  readonly changeTypeDocuments: typeof api.changeTypeDocuments;
  readonly changeTypeDocument: typeof api.changeTypeDocument;
  readonly linkDocument: typeof api.linkDocument;
  readonly linkDocuments: typeof api.linkDocuments;
  readonly lockLinkedDocuments: typeof api.lockLinkedDocuments;
  readonly unlinkDocument: typeof api.unlinkDocument;
  readonly unlinkMultiDocuments: typeof api.unlinkMultiDocuments;
  readonly updateLink: typeof api.updateLink;
  readonly updateNotes: typeof api.updateNotes;
  readonly removeNotes: typeof api.removeNotes;
  readonly uploadDocument: typeof api.uploadDocument;
  readonly uploadSupplierDocument: typeof api.uploadSupplierDocument;
  readonly rejectDocument: typeof api.rejectDocument;
  readonly duplicateAsMultiGrv: typeof api.duplicateAsMultiGrv;
  readonly getDashboardStatus: typeof api.getDashboardStatus;
  readonly getStatementTxnSearch: typeof api.getStatementTxnSearch;
  readonly getJournalEntry: typeof api.getJournalEntry;
  readonly getJEList: typeof api.getJEList;
  readonly updateJournalEntry: typeof api.updateJournalEntry;
  readonly updateJournalEntryFromInsights: typeof api.updateJournalEntryFromInsights;
  readonly getTextMap: typeof api.getTextMap;
  readonly getSettings: typeof api.getSettings;
  readonly getSlackConnection: typeof api.getSlackConnection;
  readonly disconnectSlack: typeof api.disconnectSlack;
  readonly connectSlack: typeof api.connectSlack;
  readonly getSSOParams: typeof api.getSSOParams;
  readonly disconnectErp: typeof api.disconnectErp;
  readonly updateFavoriteCompanies: typeof api.updateFavoriteCompanies;
  readonly acceptDocument: typeof api.acceptDocument;
  readonly checkActivate: typeof api.checkActivate;
  readonly updatePrefs: typeof api.updatePrefs;
  readonly splitDocument: typeof api.splitDocument;
  readonly unlinkDocuments: typeof api.unlinkDocuments;
  readonly getCompanyChatContext: typeof api.getCompanyChatContext;
  readonly getUserProfile: typeof api.getUserProfile;
  readonly getMRUTags: typeof api.getMRUTags;
  readonly signDocument: typeof api.signDocument;
  readonly signDocuments: typeof api.signDocuments;
  readonly bulkAcceptDocuments: typeof api.bulkAcceptDocuments;
  readonly bulkApprove: typeof api.bulkApprove;
  readonly bulkSetApprovals: typeof api.bulkSetApprovals;
  readonly moveDocumentToCompany: typeof api.moveDocumentToCompany;
  readonly moveDocumentsToCompany: typeof api.moveDocumentsToCompany;
  readonly mergeDocuments: typeof api.mergeDocuments;
  readonly mergeDocumentsForPrinting: typeof api.mergeDocumentsForPrinting;
  readonly getOrganization: typeof api.getOrganization;
  readonly updateOrganization: typeof api.updateOrganization;
  readonly updateOrganizationLogo: typeof api.updateOrganizationLogo;
  readonly createOrganization: typeof api.createOrganization;
  readonly getPasswordExpiration: typeof api.getPasswordExpiration;
  readonly updatePasswordExpiration: typeof api.updatePasswordExpiration;
  readonly createCompany: typeof api.createCompany;
  readonly getAllCompanies: typeof api.getAllCompanies;
  readonly exportData: typeof api.exportData;
  readonly getSignings: typeof api.getSignings;
  readonly updateSignings: typeof api.updateSignings;
  readonly removeSignings: typeof api.removeSignings;
  readonly setCompanyFeatures: typeof api.setCompanyFeatures;
  readonly getCompanyFeatures: typeof api.getCompanyFeatures;
  readonly getFTPConnection: typeof api.getFTPConnection;
  readonly saveFTPConnection: typeof api.saveFTPConnection;
  readonly getCompanyConnections: typeof api.getCompanyConnections;
  readonly syncErpIndexes: typeof api.syncErpIndexes;
  readonly setGuidSignings: typeof api.setGuidSignings;
  readonly getSigningsCopy: typeof api.getSigningsCopy;
  readonly deleteAllSignings: typeof api.deleteAllSignings;
  readonly getOrgFeatures: typeof api.getOrgFeatures;
  readonly setOrgFeatures: typeof api.setOrgFeatures;
  readonly getOrgBackupConnections: typeof api.getOrgBackupConnections;
  readonly getBackupSSOParams: typeof api.getBackupSSOParams;
  readonly disconnectOrgBackup: typeof api.disconnectOrgBackup;
  readonly getCompanyUsers: typeof api.getCompanyUsers;
  readonly createCompanyUser: typeof api.createCompanyUser;
  readonly getOrgUsers: typeof api.getOrgUsers;
  readonly downloadUsersReport: typeof api.downloadUsersReport;
  readonly createOrgUser: typeof api.createOrgUser;
  readonly updateOrgUser: typeof api.updateOrgUser;
  readonly uploadUserPicture: typeof api.uploadUserPicture;
  readonly getCompany: typeof api.getCompany;
  readonly updateCompanyLogo: typeof api.updateCompanyLogo;
  readonly updateCompany: typeof api.updateCompany;
  readonly assignOrgUser: typeof api.assignOrgUser;
  readonly revokeOrgUser: typeof api.revokeOrgUser;
  readonly bulkAssignOrgUsers: typeof api.bulkAssignOrgUsers;
  readonly bulkRevokeOrgUsers: typeof api.bulkRevokeOrgUsers;
  readonly bulkAssignOrgCompanies: typeof api.bulkAssignOrgCompanies;
  readonly bulkRevokeOrgCompanies: typeof api.bulkRevokeOrgCompanies;
  readonly revokeUserFromAllCompanies: typeof api.revokeUserFromAllCompanies;
  readonly deleteCompany: typeof api.deleteCompany;
  readonly deleteOrgUser: typeof api.deleteOrgUser;
  readonly getCompaniesByErpType: typeof api.getCompaniesByErpType;
  readonly getCurrentERPSettings: typeof api.getCurrentERPSettings;
  readonly setCurrentERPSettings: typeof api.setCurrentERPSettings;
  readonly duplicateDocument: typeof api.duplicateDocument;
  readonly getDocumentUrl: typeof api.getDocumentUrl;
  readonly getDocumentLinkedCount: typeof api.getDocumentLinkedCount;
  readonly getDocumentCsv: typeof api.getDocumentCsv;
  readonly getDocumentThumbnailUrl: typeof api.getDocumentThumbnailUrl;
  readonly getDocuments: typeof api.getDocuments;
  readonly getUnreadRequests: typeof api.getUnreadRequests;
  readonly removeDocuments: typeof api.removeDocuments;
  readonly stopDocumentProcessing: typeof api.stopDocumentProcessing;
  readonly headerTablesCorrection: typeof api.headerTablesCorrection;
  readonly getEvents: typeof api.getEvents;
  readonly getEventFilters: typeof api.getEventFilters;
  readonly getCountOfNewEvents: typeof api.getCountOfNewEvents;
  readonly exportEventsHistory: typeof api.exportEventsHistory;
  readonly getCurrencies: typeof api.getCurrencies;
  readonly getTimezones: typeof api.getTimezones;
  readonly activateErp: typeof api.activateErp;
  readonly importData: typeof api.importData;
  readonly getReconcileStatistic: typeof api.getReconcileStatistic;
  readonly getReconciliationSearchParams: typeof api.getReconciliationSearchParams;
  readonly updateReconciliationSearchParams: typeof api.updateReconciliationSearchParams;
  readonly reconcileTransaction: typeof api.reconcileTransaction;
  readonly undoTransaction: typeof api.undoTransaction;
  readonly anGetDocument: typeof api.anGetDocument;
  readonly anGetDocumentMessagingHistory: typeof api.anGetDocumentMessagingHistory;
  readonly anUpdateRequestTransactionAnonymously: typeof api.anUpdateRequestTransactionAnonymously;
  readonly getDocumentMessagingHistory: typeof api.getDocumentMessagingHistory;
  readonly createTransactionRequest: typeof api.createTransactionRequest;
  readonly markStatementRequestAsRead: typeof api.markStatementRequestAsRead;
  readonly getOrganizationList: typeof api.getOrganizationList;
  readonly updateApproval: typeof api.updateApproval;
  readonly signApproval: typeof api.signApproval;
  readonly rejectApproval: typeof api.rejectApproval;
  readonly getApprovalApproveReasons: typeof api.getApprovalApproveReasons;
  readonly updateApprovalApproveReasons: typeof api.updateApprovalApproveReasons;
  readonly changeBulkApprovalFlowStatus: typeof api.changeBulkApprovalFlowStatus;
  readonly bulkApprovalReplace: typeof api.bulkApprovalReplace;
  readonly getCategories: typeof api.getCategories;
  readonly moveDocumentToCategory: typeof api.moveDocumentToCategory;
  readonly moveAllCategoryDocumentsToOtherCategory: typeof api.moveAllCategoryDocumentsToOtherCategory;
  readonly setDocumentAsCover: typeof api.setDocumentAsCover;
  readonly gridDocumentsExport: typeof api.gridDocumentsExport;
  readonly getWorkspaceGridRows: typeof api.getWorkspaceGridRows;
  readonly getWorkspaceGridHeaders: typeof api.getWorkspaceGridHeaders;
  readonly getInsightsGridHeaders: typeof api.getInsightsGridHeaders;
  readonly getInsightsGridRows: typeof api.getInsightsGridRows;
  readonly getInsightsGridFilterListByField: typeof api.getInsightsGridFilterListByField;
  readonly getDocumentsGridFilterListByField: typeof api.getDocumentsGridFilterListByField;
  readonly getPresets: typeof api.getPresets;
  readonly createPreset: typeof api.createPreset;
  readonly updatePreset: typeof api.updatePreset;
  readonly deletePreset: typeof api.deletePreset;
  readonly getPreset: typeof api.getPreset;
  readonly getVendorBasedApprovalsRows: typeof api.getVendorBasedApprovalsRows;
  readonly getVendorBasedApprovalsHeaders: typeof api.getVendorBasedApprovalsHeaders;
  readonly getVendorBasedApprovalsFilterListByField: typeof api.getVendorBasedApprovalsFilterListByField;
  readonly getPolicyManagementGridRows: typeof api.getPolicyManagementGridRows;
  readonly getPolicyManagementGridHeaders: typeof api.getPolicyManagementGridHeaders;
  readonly updatePolicyManagementGridData: typeof api.updatePolicyManagementGridData;
  readonly updateVendorBasedApprovals: typeof api.updateVendorBasedApprovals;
  readonly resetVendorBasedApprovalsDefaults: typeof api.resetVendorBasedApprovalsDefaults;
  readonly getVendorBasedApprovalsDefaults: typeof api.getVendorBasedApprovalsDefaults;
  readonly updateVendorBasedApprovalsDefaults: typeof api.updateVendorBasedApprovalsDefaults;
  readonly getVendorBasedApprovalsAdditionalEditors: typeof api.getVendorBasedApprovalsAdditionalEditors;
  readonly addApproval: typeof api.addApproval;
  readonly removeApproval: typeof api.removeApproval;
  readonly addAdvancedApprovalGroup: typeof api.addAdvancedApprovalGroup;
  readonly removeAdvancedApprovalGroup: typeof api.removeAdvancedApprovalGroup;
  readonly changeOrderApproval: typeof api.changeOrderApproval;
  readonly setApprovalFlowStatus: typeof api.setApprovalFlowStatus;
  readonly getEmailData: typeof api.getEmailData;
  readonly getNotifications: typeof api.getNotifications;
  readonly updateNotifications: typeof api.updateNotifications;
  readonly getDocumentHotkeys: typeof api.getDocumentHotkeys;
  readonly updateUserFeatures: typeof api.updateUserFeatures;
  readonly jeGetIndexForm: typeof api.jeGetIndexForm;
  readonly getDocumentsDownloadURL: typeof api.getDocumentsDownloadURL;
  readonly getSuppliersDefaults: typeof api.getSuppliersDefaults;
  readonly updateSuppliersDefaults: typeof api.updateSuppliersDefaults;
  readonly importCorruptedVendorPreferences: typeof api.importCorruptedVendorPreferences;
  readonly importVendorPreferences: typeof api.importVendorPreferences;
  readonly exportVendorPreferences: typeof api.exportVendorPreferences;
  readonly exportVendorPreferencesNew: typeof api.exportVendorPreferencesNew;
  readonly importCorruptedVendorPreferencesNew: typeof api.importCorruptedVendorPreferencesNew;
  readonly importVendorPreferencesBackground: typeof api.importVendorPreferencesBackground;
  readonly ignoreDocumentWarnings: typeof api.ignoreDocumentWarnings;
  readonly getAliases: typeof api.getAliases;
  readonly updateAliases: typeof api.updateAliases;
  readonly getDocumentVendor: typeof api.getDocumentVendor;
  readonly sendDocByEmail: typeof api.sendDocByEmail;
  readonly getEmailsForAutocomplete: typeof api.getEmailsForAutocomplete;
  readonly getWSConnectionUrl: typeof api.getWSConnectionUrl;
  readonly getApprovalGroups: typeof api.getApprovalGroups;
  readonly createApprovalsGroup: typeof api.createApprovalsGroup;
  readonly updateApprovalGroup: typeof api.updateApprovalGroup;
  readonly deleteApprovalsGroup: typeof api.deleteApprovalsGroup;
  readonly getApprovers: typeof api.getApprovers;
  readonly getAllApprovalUsers: typeof api.getAllApprovalUsers;
  readonly createApprover: typeof api.createApprover;
  readonly deleteApprover: typeof api.deleteApprover;
  readonly getAdvancedApprovalsGroups: typeof api.getAdvancedApprovalsGroups;
  readonly createAdvancedApprovalsGroup: typeof api.createAdvancedApprovalsGroup;
  readonly updateAdvancedApprovalGroup: typeof api.updateAdvancedApprovalGroup;
  readonly deleteAdvancedApprovalsGroup: typeof api.deleteAdvancedApprovalsGroup;
  readonly getExtractedTableData: typeof api.getExtractedTableData;
  readonly getExtractedTableFieldsMapping: typeof api.getExtractedTableFieldsMapping;
  readonly learnExtractedTableFields: typeof api.learnExtractedTableFields;
  readonly extractLines: typeof api.extractLines;
  readonly getOrganizationApiKeys: typeof api.getOrganizationApiKeys;
  readonly createOrganizationApiKey: typeof api.createOrganizationApiKey;
  readonly updateOrganizationApiKey: typeof api.updateOrganizationApiKey;
  readonly deleteOrganizationApiKey: typeof api.deleteOrganizationApiKey;
  readonly getUserIP: typeof api.getUserIP;
  readonly notifyOfAppActivity: typeof api.notifyOfAppActivity;
  readonly requestAccessToModule: typeof api.requestAccessToModule;
  readonly pollingDeferredTask: typeof api.pollingDeferredTask;
}

// Service constructor that simply returns existing api object
export const makeApiService = Effect.sync(() => api);

export class ApiService extends Context.Tag('ApiService')<ApiService, Effect.Effect.Success<typeof makeApiService>>() {
  // ApiServiceLayer but presented as static Service field not to import
  // it separately where its required but invoke as ApiService.make
  static make = Layer.effect(this, makeApiService);
}

export const ApiServiceLayer = Layer.effect(ApiService, makeApiService);
